<template>
  <div class="upgrade-plan-container">
    <div class="row">
      <div class="col-md-12 text-center">
        <!-- <video width="576" height="384" controls>
          <source :src="video" type="video/mp4" />
        </video> -->
        <iframe :src="video" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
      </div>
      <div class="col-md-12 text-center mt-3">
        <img class="upgrade-lock" src="/storage/icons/lock.svg" />
      </div>
      <div class="col-md-12 text-center mt-3">
        <a class="btn text-white btn-upgrade" :href="link" target="_blank">PURCHASE TO UNLOCK THIS UPGRADE</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'upgradePlan',

  props: {
    link: { type: String, default: null },
    video: {type: String, default : '/storage/home/upgrade.mp4'}
  }
}
</script>

<style>
  .upgrade-plan-container .btn-upgrade {
    background: #333;
    border-radius: 20px;
    font-weight: 600;
    line-height: 22px;
    text-transform: uppercase;
    font-size: 17px;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/upgradePlan.vue